import { render, staticRenderFns } from "./HistoryShopping.vue?vue&type=template&id=d0f74528&scoped=true&"
import script from "./HistoryShopping.vue?vue&type=script&lang=js&"
export * from "./HistoryShopping.vue?vue&type=script&lang=js&"
import style0 from "./HistoryShopping.vue?vue&type=style&index=0&id=d0f74528&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/customerHome.css?vue&type=style&index=1&id=d0f74528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f74528",
  null
  
)

export default component.exports